<template>
  <v-data-table
    :headers="[
      { value: 'data-table-expand' },
      { value: 'started_at', text: 'Started At' },
      { value: 'session_id', text: 'Session' },
      {
        value: 'first_source_id_name',
        text: 'First Source'
      },
      { value: 'clicks', text: 'Paid clicks' },
      { value: 'conversions', text: 'Conversions' }
    ]"
    :items="sourceStat.table_elements"
    item-key="session_id"
    disable-pagination
    hide-default-footer
    show-expand
    :expanded.sync="expandedClicks"
    @click:row="showClicks"
  >
    <template v-slot:item="{ index, item, expand, isExpanded }">
      <tr :class="getRowClassLevel0(index, item)">
        <td style="width: 70px">
          <v-btn icon rounded @click="expand(!isExpanded)">
            <v-icon>{{ isExpanded ? "expand_less" : "expand_more" }}</v-icon>
          </v-btn>
        </td>
        <td style="width: 140px">
          <DateTimeColumn :timestamp="item.started_at" />
        </td>
        <td>
          <div class="session">
            {{ item.session_id }}
            <span v-if="item.violations && item.violations.length > 0">
              &nbsp;
              <v-tooltip
                top
                v-for="violation in item.violations"
                :key="violation.id"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                    style="background-color: crimson; color: white"
                    x-small
                    v-bind="attrs"
                    v-on="on"
                    >{{ violation.name }}</v-chip
                  >
                </template>
                <span>{{ violation.string }}</span>
              </v-tooltip>
            </span>
          </div>
        </td>
        <td style="width: 8%">
          {{ item.first_source_id_name }}
        </td>
        <td style="width: 8%">{{ item.clicks }}</td>
        <td style="width: 8%">
          <Chip :color="'green'" :count="item.conversions" />
        </td>
      </tr>
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td
        :colspan="headers.length"
        style="padding: 0; background-color: #f0f0f0;"
      >
        <div v-if="item.sub_sessions.length === 1">
          <div style="padding-left: 70px;">
            <HitsTable :hits="item.sub_sessions[0].hits" />
          </div>
        </div>
        <div v-else>
          <v-data-table
            :headers="[
              { value: 'data-table-expand' },
              { value: 'started_at', text: 'Started At' },
              { value: 'click_id', text: 'Click Id' },
              {
                value: 'first_source_id_name',
                text: 'First Source'
              },
              { value: 'hits_count', text: 'Clicks' },
              {
                value: 'conversions_count',
                text: 'Conversions'
              }
            ]"
            :items="item.sub_sessions"
            item-key="click_id"
            disable-pagination
            hide-default-footer
            hide-default-header
            show-expand
            :expanded="expanded"
            @click:row="showHits"
          >
            <template v-slot:item="{ index, item, expand, isExpanded }">
              <tr :class="getRowClassLevel1(index, item)">
                <td
                  style="width: 70px; padding-left: 30px; background-color: #f0f0f0;"
                >
                  <v-btn icon rounded @click="expand(!isExpanded)">
                    <v-icon>{{
                      isExpanded ? "expand_less" : "expand_more"
                    }}</v-icon>
                  </v-btn>
                </td>
                <td style="width: 140px">
                  <DateTimeColumn :timestamp="item.started_at" />
                </td>
                <td>
                  <div class="session">
                    {{ item.click_id }}
                  </div>
                </td>
                <td style="width: 8%">
                  {{ item.first_source_id_name }}
                </td>
                <td style="width: 8%">{{ item.hits_count }}</td>
                <td style="width: 8%">
                  <Chip :color="'#ff0000'" :count="item.conversions_count" />
                </td>
              </tr>
            </template>
            <template v-slot:expanded-item="{ headers, item }">
              <td
                :colspan="headers.length"
                style="padding: 0 0 0 80px; background-color: #f0f0f0;"
              >
                <HitsTable :hits="item.hits" />
              </td>
            </template>
          </v-data-table>
        </div>
      </td>
    </template>
  </v-data-table>
</template>

<script>
import Chip from "@/components/_Tables/Chip";
import DateTimeColumn from "@/components/_Tables/DateTimeColumn";
import HitsTable from "@/components/_Tables/HitsTable";

export default {
  name: "SessionDetailsTable",
  components: { Chip, DateTimeColumn, HitsTable },
  props: {
    sourceStat: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      expanded: [],
      expandedClicks: [],
      bannedSessionId: null,
      bannedClickId: null
    };
  },
  beforeUpdate() {
    this.bannedSessionId = null;
    this.bannedClickId = null;
  },
  methods: {
    getRowClassLevel0(index, item) {
      if (item.is_banned && !this.bannedSessionId) {
        this.bannedSessionId = item.session_id;
      }

      return {
        "is-paid-click-level-0": item.is_payed === true,
        "is-conversion-click-level-0": item.is_converted === true,
        "is-banned-click-level-0": item.is_banned === true,
        "is-banned-click-border-level-0":
          item.session_id === this.bannedSessionId && index > 0
      };
    },
    getRowClassLevel1(index, item) {
      if (item.is_banned && !this.bannedClickId) {
        this.bannedClickId = item.click_id;
      }

      return {
        "is-paid-click-level-0": item.is_payed === true,
        "is-conversion-click-level-0": item.is_converted === true,
        "is-banned-click-level-0": item.is_banned === true,
        "is-banned-click-border-level-0":
          item.click_id === this.bannedClickId && index > 0
      };
    },
    showHits(item) {
      let isExists = this.expanded.find(
        inner => inner.click_id === item.click_id
      );
      if (!isExists) {
        this.expanded.push(item);
      } else {
        this.expanded = this.expanded.filter(
          innerItem => innerItem.click_id !== item.click_id
        );
      }
    },
    showClicks(item) {
      let isExists = this.expandedClicks.find(
        innerItem => innerItem.session_id === item.session_id
      );
      if (!isExists) {
        this.expandedClicks.push(item);
      } else {
        this.expandedClicks = this.expandedClicks.filter(
          innerItem => innerItem.session_id !== item.session_id
        );
      }
    }
  }
};
</script>

<style>
.is-paid-click-level-0 {
  background-color: #e1e8ff;
  color: #0d47e7;
}
.is-conversion-click-level-0 {
  background-color: #e1ffe2;
  color: #33691e;
}
.is-banned-click-border-level-0 {
  box-shadow: inset 0 1px crimson;
}
.is-banned-click-level-0 {
  color: crimson !important;
}
.is-paid-click {
  background-color: #e1e8ff;
  color: #0d47e7;
}
.is-conversion-click {
  background-color: #e1ffe2;
  color: #33691e;
}
.is-banned-click {
  color: crimson;
}
.v-data-table__expanded__content {
  box-shadow: none !important;
  background-color: #f3f3f3;
}
</style>
